import ascendingPrice from "@irati/payments/utils/sortByPrice";
export var buildProductOptions = function (reward, intl) {
    if (reward) {
        var results = ascendingPrice(reward.products.results);
        return results
            .map(function (_a) {
            var uuid = _a.uuid, price = _a.price, currency = _a.currency;
            return ({
                label: intl.formatNumber(parseFloat(price), {
                    style: "currency",
                    currency: currency
                }),
                value: uuid
            });
        });
    }
    return [];
};
export var getTotal = function (product, recipientsCount) {
    if (!product) {
        return 0;
    }
    return product.price * recipientsCount;
};
